const deduccionesRoutes = [
  {
    path: "deducciones",
    name: "deducciones",
    component: () => import("../Deducciones.vue"),
  },
];

export default deduccionesRoutes;
